import { createFileRoute, redirect } from "@tanstack/react-router";

import { MARKETING_FLAGS } from "@/lib/marketing-flags";

/**
 * A short URL for adverts and emails. It exists only to send people to the
 * form, which lives on `/partners` itself — a separate application page would
 * be a second thing to keep in step with the one that sells it.
 *
 * Excluded from the sitemap (`vite.config.ts`) for the same reason the sign-up
 * spellings are: advertising a redirect gains nothing and reports as "Page with
 * redirect" in Search Console.
 */
export const Route = createFileRoute("/(public)/partners/apply")({
  beforeLoad: () => {
    throw redirect({
      hash: "apply",
      to: MARKETING_FLAGS.partners ? "/partners" : "/",
    });
  },
});
